var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.125 9.09863V20.1799C33.125 20.3486 33.0562 20.5049 32.9437 20.6236L20.275 33.2924C20.1562 33.4049 20 33.4736 19.8312 33.4736H5.625C4.24375 33.4736 3.125 32.3549 3.125 30.9736V9.09863C3.125 8.75488 3.40625 8.47363 3.75 8.47363H32.5C32.8438 8.47363 33.125 8.75488 33.125 9.09863Z",
    fill: "#FFB742"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.375 4.09863V7.84863C34.375 8.87988 33.5312 9.72363 32.5 9.72363H3.75C2.71875 9.72363 1.875 8.87988 1.875 7.84863V4.09863C1.875 3.06738 2.71875 2.22363 3.75 2.22363H32.5C33.5312 2.22363 34.375 3.06738 34.375 4.09863Z",
    fill: "#FFA132"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1248 28.4736C38.1248 33.9861 33.6373 38.4736 28.1248 38.4736C14.8588 37.9221 14.8627 19.0231 28.1249 18.4736C33.6373 18.4736 38.1248 22.9611 38.1248 28.4736Z",
    fill: "#20B485"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1248 2.22363V14.0986C23.1377 14.5546 22.6152 14.8714 22.2185 14.6549L20.0435 13.5674L18.4685 14.6174C18.2623 14.7611 17.9873 14.7611 17.781 14.6174L16.206 13.5674L14.031 14.6549C13.636 14.8702 13.1108 14.5545 13.1248 14.0986V2.22363H23.1248Z",
    fill: "#EEEAE7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87507 25.3486H11.8751C12.6909 25.3453 12.6936 24.1022 11.875 24.0986H6.87507C6.05926 24.1019 6.05657 25.3451 6.87507 25.3486Z",
    fill: "#FAD582"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8751 27.8486H6.87507C6.05925 27.8519 6.05657 29.0951 6.87513 29.0986H11.8751C12.6909 29.0953 12.6936 27.8522 11.8751 27.8486Z",
    fill: "#FAD582"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3191 25.1672L24.8191 32.6672C24.2345 33.2355 23.3552 32.3664 23.9317 31.7797L31.4317 24.2797C32.0122 23.7063 32.897 24.5811 32.3191 25.1672Z",
    fill: "#EEEAE7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 31.5988C33.6671 34.8962 28.8324 34.8955 28.75 31.5987C28.8329 28.3014 33.6676 28.302 33.75 31.5988Z",
    fill: "#EEEAE7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 27.8486C21.7028 27.7657 21.7034 22.9311 25.0002 22.8486C28.2975 22.9315 28.2969 27.7662 25.0001 27.8486Z",
    fill: "#EEEAE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGst);
export default __webpack_public_path__ + "static/media/gst.fe7624f1bc483c84fff86097fac62e22.svg";
export { ForwardRef as ReactComponent };